import axiosInstance from "../../api/axiosInstance";

// What happened to the emails sent to an address (last 30 days) and whether
// it's on the suppression list. Staff with control-users only.
export const fetchEmailLogsAPI = (email) =>
  axiosInstance.get("email/logs", { params: { email } });

// Take an address off the suppression list (the player fixed their mailbox).
export const removeEmailSuppressionAPI = (email) =>
  axiosInstance.delete(`email/suppressions/${encodeURIComponent(email)}`);
